import { MathJax, MathJaxContext } from 'better-react-mathjax';
import { PropTypes } from 'prop-types';
import React from 'react';

const MathJaxWrapper = ({ children }) => {
  const config = {
    loader: { load: ['input/asciimath', '[tex]/html'] },
    tex: {
      packages: { '[+]': ['html'] },
      inlineMath: [
        ['$', '$'],
        ['\\(', '\\)']
      ],
      displayMath: [
        ['$$', '$$'],
        ['\\[', '\\]']
      ]
    }
  };

  return (
    <MathJaxContext version={3} config={config}>
      <MathJax>{children}</MathJax>
    </MathJaxContext>
  );
};

MathJaxWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default MathJaxWrapper;
